import { z } from 'zod';
export const StepFunctionErrorSchema = z.object({
    errorMessage: z.string(),
    errorType: z.string().optional(),
    trace: z.string().array().optional(),
});
export const isStepFunctionError = (error) => StepFunctionErrorSchema.safeParse(error).success;
export const ErrorInputSchema = z.object({
    Cause: z.string(),
    Error: z.string(),
});
